import request from 'axios';
window.req = request;
const getEvents = async (query) => {
    let response = await request.get("https://www.vam.ac.uk/services/content/exhibition/current", {query: query});
    return response;
}

const getEvent = async (query, store) => {
    let key, value = null;
    let promise;

    if( query ) {
        key   = Object.keys(query)[0];
        value = Object.values(query)[0];
    }

    if( store && key && value ) {
        let event = store.events.find((e) => e[key] === value);

        if( event ) {
            promise = new Promise((resolve) => {
                resolve({data: event});
            });

            return promise;
        }
    }

    const events = await getEvents();
    let   data = null;
    try {
        data = await events.data;
        data = data[0].exhibitions;
    }catch{
        return null;
    }

    promise = new Promise((resolve) => {
        let result = null;

        if( key && value ) {
            result = data.find((d) => d[key] === value);
        }

        resolve({data: result});
    });

    return promise;
}
window.getEvents = getEvents;

export { getEvents, getEvent };
